import nodeService from '@/services/nodejs/index'
import { getTokenNode } from '@/store/utils/tokenNode'
import { publicLogoSource } from '@/store/utils/placePublicData'

function withImageType(blob, filePath) {
  const type = String((blob && blob.type) || '').toLowerCase()
  if (type.indexOf('image/') === 0) return blob
  const ext = String(filePath || '')
    .split('.')
    .pop()
    .toLowerCase()
    .split('?')[0]
  const mime = {
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    webp: 'image/webp',
    svg: 'image/svg+xml',
  }[ext]
  if (!mime) return blob
  return new Blob([blob], { type: mime })
}

async function isImageBlob(blob) {
  if (!blob || !blob.size || typeof blob.slice !== 'function') return false
  const type = String(blob.type || '').toLowerCase()
  if (type.indexOf('image/') === 0) return true
  if (
    type.indexOf('json') !== -1 ||
    type.indexOf('text/') === 0 ||
    type.indexOf('html') !== -1
  ) {
    return false
  }
  const head = new Uint8Array(await blob.slice(0, 12).arrayBuffer())
  const png =
    head[0] === 0x89 && head[1] === 0x50 && head[2] === 0x4e && head[3] === 0x47
  const jpeg = head[0] === 0xff && head[1] === 0xd8
  const gif = head[0] === 0x47 && head[1] === 0x49 && head[2] === 0x46
  const webp =
    head[0] === 0x52 &&
    head[1] === 0x49 &&
    head[2] === 0x46 &&
    head[3] === 0x46
  return png || jpeg || gif || webp
}

async function objectUrlFromBlob(blob, filePath) {
  if (!(await isImageBlob(blob))) return ''
  return URL.createObjectURL(withImageType(blob, filePath))
}

async function blobJson(blob) {
  if (!blob || typeof blob.text !== 'function' || !blob.size) return null
  const type = String(blob.type || '').toLowerCase()
  if (type.indexOf('image/') === 0) return null
  let text = ''
  try {
    text = (await blob.text()).trim()
  } catch (error) {
    return null
  }
  if (!text || (text[0] !== '[' && text[0] !== '{')) return null
  try {
    return JSON.parse(text)
  } catch (error) {
    return null
  }
}

function pickListedFile(files, filePath) {
  const list = (Array.isArray(files) ? files : [files]).filter(
    (item) => item && item.id != null
  )
  if (!list.length) return null
  const wanted = String(filePath || '')
  return (
    list.find((item) => {
      const stored = item && item.path
      if (!stored || !wanted) return false
      return stored === wanted || stored.endsWith(wanted) || wanted.endsWith(stored)
    }) || list[0]
  )
}

export async function fetchFileObjectUrl(filePath) {
  if (!filePath) return ''
  let response
  try {
    response = await nodeService.getFileByPathV3(filePath)
  } catch (error) {
    return ''
  }

  const direct = await objectUrlFromBlob(response && response.data, filePath)
  if (direct) return direct

  const listed = await blobJson(response && response.data)
  const file = listed && pickListedFile(listed, filePath)
  if (!file || !getTokenNode()) return ''

  try {
    const download = await nodeService.downloadFileById(file.id)
    return await objectUrlFromBlob(download && download.data, file.path || filePath)
  } catch (error) {
    return ''
  }
}

export async function loadPublicLogoUrl(data) {
  const resolved = publicLogoSource(data)
  if (!resolved || !resolved.src) {
    return { url: '', owned: false, configured: false }
  }
  if (resolved.type === 'url') {
    return { url: resolved.src, owned: false, configured: true }
  }
  const url = await fetchFileObjectUrl(resolved.src)
  return { url: url || '', owned: !!url, configured: true }
}
